var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cell-info"},[_c('img',{class:_vm.cellIconClasses,style:(_vm.iconClass),attrs:{"src":_vm.cellIcon,"width":_vm.iconWidth,"height":_vm.iconHeight}}),_c('span',{staticClass:"cell-type"},[_vm._v(_vm._s(_vm.cellLabelText))]),_c('span',{staticClass:"cell-title"},[_vm._v(" "+_vm._s(_vm.cellTitle)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }